module.exports = __webpack_public_path__ + "static/img08-8f5d74bc6c3f925b61785099068994db.jpg";